var render = function render(){var _vm=this,_c=_vm._self._c;return _c('UserActivityView',[(_vm.isActivityGoalEnabled)?_c('ActivityInfo'):_vm._e(),_vm._v(" "),_c('MyActivity')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }